import * as employeesTypes from './employeesTypes';
import { fetchEmployeeDetailApi, updateEmployeeDetailsApi } from 'src/services/employees.service';

export const getEmployeeDetail = employeeId => {
  return async dispatch => {
    dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, true));
    await fetchEmployeeDetailApi(employeeId)
      .then(res => {
        if (res && !res.error) {
          dispatch(getProfileDetailSuccess(res));
          dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, false));
        } else {
          dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, false));
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const getProfileDetailSuccess = payload => {
  return {
    type: employeesTypes.GET_EMPLOYEE_DETAIL_SUCCESS,
    payload,
  };
};

export const updateEmployeeDetails = formData => {
  return async dispatch => {
    dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, true));
    await updateEmployeeDetailsApi(formData)
      .then(res => {
        if (res && !res.error) {
          dispatch(getProfileDetailSuccess(res));
          dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, false));
        } else {
          dispatch(isLoading(employeesTypes.LOADING_EMPLOYEE, false));
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.log(err);
        throw new Error(err.message);
      });
  };
};

export const isLoading = (type, isLoading) => {
  return {
    type,
    isLoading,
  };
};

export default {
  getEmployeeDetail,
  isLoading,
  updateEmployeeDetails,
};
